import { render, staticRenderFns } from "./AcessarDocumentosAtaBtnMaisAcoes.vue?vue&type=template&id=192607b6&scoped=true"
import script from "./AcessarDocumentosAtaBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarDocumentosAtaBtnMaisAcoes.vue?vue&type=script&lang=js"
import style0 from "./AcessarDocumentosAtaBtnMaisAcoes.vue?vue&type=style&index=0&id=192607b6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192607b6",
  null
  
)

export default component.exports